import { inject, Injectable } from '@angular/core';
import {
  ApiDataAccess,
  ConnectionHttpService,
  Dictionary, Id,
  ReadonlyHttpApiCollectionRepository,
  ReadonlyHttpApiRepository,
  Result
} from '@softline/core';
import { Objekt } from './objekt';
import { SOFTLINE_API_OBJECTS } from '../wws-core.api';
import { Scan } from '@softline/application';

@Injectable({ providedIn: 'root' })
export class ObjektRepository extends ReadonlyHttpApiRepository<Result<Objekt>, {id: Id}> {

  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_OBJECTS);
  }

  override getLoadPathParams(params: { id: Id }): Dictionary<unknown> | undefined {
    return params;
  }
}
